// Polyfills for older browsers (must be first)
import 'regenerator-runtime/runtime';
import React from "react";
import ReactDOM from "react-dom/client";
import Providers from "./Providers";
import App from "./App";
import * as Sentry from "@sentry/react";

// Polyfill for window.location.origin (IE11 and older browsers)
if (!window.location.origin) {
  window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}

window.isIframe = window !== window.parent;

Sentry.init({
  dsn: "https://f69c4ab5efe517f791f18e6b2b94549f@o4510097282564096.ingest.de.sentry.io/4510120676425808",
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
  beforeSend(event, hint) {
    const error = hint?.originalException;
    const msg = typeof error?.message === "string" ? error.message : "";
    // Filter out AbortError — cancelled fetch requests (component unmounts)
    if (error?.name === "AbortError" || msg.includes("AbortError")) return null;
    // Filter out Network Error — user lost internet, not a code bug
    if (msg === "Network Error") return null;
    return event;
  },
});
/** Friendly crash UI for uncaught errors */
function CrashFallback() {
  return (
    <div style={{ padding: 24, fontFamily: "system-ui" }}>
      <h2>Something went wrong</h2>
      <p>We’ve been notified and are looking into it.</p>
    </div>
  );
}

/** -------- RENDER -------- */
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary fallback={<CrashFallback />} showDialog>
    <Providers>
      <App />
    </Providers>
  </Sentry.ErrorBoundary>
);
